/**
 * Agent entity type registry entry.
 *
 * ahoy_agent is a principal-kind agent record — reachable by link/search only
 * (no nav entry). This is a deliberate product decision: agents are not
 * browsable from the sidebar like contacts or companies.
 */

import { getDisplayName } from '../../utils/getDisplayName';
import type { EntityTypeConfig } from './entityTypeRegistry';

export const AGENT_ENTITY_TYPES: Record<string, EntityTypeConfig> = {
  ahoy_agent: {
    displayName: 'Agent',
    pluralDisplayName: 'Agents',
    color: 'gray',
    bannerGradient: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
    getDisplayName,
    // ahoy_hidden: internal marker.
    // ahoy_created_at / ahoy_updated_at: system noise on a settings-style
    //   record — deliberately hidden.
    // The visible settings (ahoy_enabled, ahoy_add_contacts,
    //   ahoy_merge_contacts, ahoy_assign_contacts, ahoy_edit_contacts,
    //   ahoy_pipeline_grants) render via standard OverviewSection editors.
    //
    // Deliberately NO slideoutTabs: the tabbed slideout body is automation
    // machinery (config-schema gating, code/testcases tabs) — the agent is a
    // plain record and uses the standard stacked body. Its run history
    // (ahoy_agent_ran events) is its timeline.
    hiddenProperties: ['ahoy_hidden', 'ahoy_created_at', 'ahoy_updated_at'],
    components: {
      // No ahoy_summary — suppress the summary card.
      summary: null,
    },
    timelineConfig: {
      includeAssociatedEvents: false,
      associatedEventTypes: [],
      groupByDate: true,
      defaultFilters: {},
    },
    routes: {
      list: '/:orgId/crm/ahoy_agent',
      detail: '/:orgId/crm/ahoy_agent/:id',
    },
  },
};
